'use strict';

import './component.scss';
import './images/not-found-img.png';
import './images/privacy-policy-img.png';
import './images/support-img.png';
import './images/forbidden-img.png';
import './images/cookie-img.png';
import './images/session-expired-img.png';
import './images/user-locked-img.png';
import './images/user-deleted-img.png';
import './images/user-logged-out-img.png';
